import React, {Component} from "react";
import Chips from 'react-chips';

var axios = require('axios');
var _ = require('lodash');

class Venue extends Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			info: "",
			debug: false,
			venue: {
				feed: {},
				address: {},
				location: {},
				options: {},
				photos: []
			},
			parameters: {
				name: "",
				description: "",
				expense: "",
				override: 0,
				options: {
					blacklisted: false,
					recommended: false,
					rating: false,
					customised: false,
					special: false,
					gallery: false
				},
				address: {
					line1: "",
					locality: "",
					city: "",
					state: "",
					postalCode: ""
				},
				phone: "",
				email: "",
				website: "",
				location: {
					type: "",
					coordinates: [0, 0]
				},
				categories: [],
				mood: [],
				occasions: [],
				special: ""
			},
			tags: {
				type: [],
				mood: [],
				occasions: []
			},
			upload: null
		};
	}
	componentDidMount()
	{
		this.getTags()
			.then(response => {

				let tags = {};

				response.data.forEach(function(element){

					if (tags[element.category] === undefined)
					{
						tags[element.category] = [];
					}

					tags[element.category].push(element.name);
				});

				let newState = {...this.state};
				newState.tags = tags;
				this.setState(newState);

				if (this.props.match.params.id === "new")
				{
					document.title = "DateNight: Add New Venue";
				}
				else
				{
					this.props.getVenue(this.props.match.params.id)
						.then(response => {
							document.title = "DateNight: Venue (" + response.data.name + ")";

							let newState = {...this.state};
							newState.venue = response.data;
							newState.parameters.id = response.data.id;
							newState.parameters.name = response.data.name;
							newState.parameters.description = response.data.description;
							newState.parameters.special = response.data.special || "";

							newState.parameters.type = response.data.type;
							newState.parameters.mood = typeof response.data.mood === 'string' ? [response.data.mood] : response.data.mood;
							newState.parameters.occasions = typeof response.data.occasions === 'string' ? [response.data.occasions] : response.data.occasions;

							newState.parameters.expense = response.data.expense;

							newState.parameters.override = response.data.rating;

							newState.parameters.options.blacklisted = response.data.options.blacklisted;
							newState.parameters.options.recommended = response.data.options.recommended;
							newState.parameters.options.rating = response.data.options.rating;
							newState.parameters.options.customised = response.data.options.customised;
							newState.parameters.options.special = response.data.options.special || false;
							newState.parameters.options.gallery = response.data.options.gallery || false;

							newState.parameters.address = {
								line1: (response.data.address.line1 === undefined) ? "" : response.data.address.line1,
								locality: (response.data.address.locality === undefined) ? "" : response.data.address.locality,
								city: (response.data.address.city === undefined) ? "" : response.data.address.city,
								state: (response.data.address.state === undefined) ? "" : response.data.address.state,
								postalCode: (response.data.address.postalCode === undefined) ? "" : response.data.address.postalCode
							};

							newState.parameters.phone = (response.data.phone === undefined) ? "" : response.data.phone;
							newState.parameters.email = (response.data.email === undefined) ? "" : response.data.email;
							newState.parameters.website = (response.data.website === undefined) ? "" : response.data.website;

							newState.parameters.location = response.data.location;
							newState.parameters.categories = (response.data.categories === undefined) ? [] : response.data.categories;

							if (newState.venue.photos === undefined)
							{
								newState.venue.photos = [];
							}

							this.setState(newState);
						})
						.catch(error => {
							this.handleError(error);
						});
				}
			})
			.catch(error => {
				this.handleError(error);
			})
	}
	toggleDebug = () =>	{

		let newValue = (this.state.debug === true) ? false : true;
		this.setState({debug: newValue});
	}
	handleSubmit = (event) => {

		event.preventDefault();

		if (this.state.venue.id === undefined)
		{
			this.props.addVenue(this.state.parameters)
				.then(response => {

					if (response.data.photos === undefined) {
						response.data.photos = [];
					}

					this.setState({venue: response.data});
					alert('New venue added');
				})
				.catch(error => {
					this.handleError(error);
				});
		}
		else
		{
			this.props.updateVenue(this.state.parameters)
				.then(response => {

					if (response.data.photos === undefined) {
						response.data.photos = [];
					}

					this.setState({venue: response.data});
					alert('Venue updated');
				})
				.catch(error => {
					this.handleError(error);
				});
		}
	}
	handleError = (error) => {

		let response = "";

		for (var prop in error.response.data)
		{
			response = error.response.data[prop];
			break;
		}

		let newState = {...this.state};
		newState.info = response.data;
		this.setState(newState);

	}
	handleInputChange = (event) => {
		const target = event.target;
		let value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		let newState = {...this.state};

		if (name.startsWith("address_"))
		{
			newState.parameters.address[name.replace("address_", "")] = value;
		}
		else if (name.startsWith("options_"))
		{
			newState.parameters.options[name.replace("options_", "")] = value;
		}
		else if (name.startsWith("location_"))
		{
			let index = (name === "location_latitude") ? 1 : 0;
			newState.parameters.location.coordinates[index] = value;
		}
		else
		{
			newState.parameters[name] = value;
		}

		this.setState(newState);
	}
	getTags = () => {
		return new Promise((fulfil, reject) => {
			axios.get(process.env.REACT_APP_API_ROOT + "tags/")
				.then(fulfil)
				.catch(reject);
		});
	}
	submitUpload = (event) => {

		event.preventDefault();

		let data = new FormData();
		data.append("id", this.state.venue.id);
		data.append("file", this.fileInput.files[0]);

		this.props.uploadPhoto(data)
			.then(response => {
				let newState = {...this.state};
				newState.venue.photos = response.data;
				this.setState(newState);
			})
			.catch(error => {
				this.handleError(error);
			});
	}
	handlePhotoUpdate = (parameters) => {
		this.props.updatePhoto(parameters)
			.then(response => {
				this.props.getPhotos(this.state.venue.id)
					.then(response => {
						let newState = {...this.state};
						newState.venue.photos = response.data;
						this.setState(newState);
						alert('Photo saved');
					})
					.catch(error => {
						this.handleError(error);
					});
			})
			.catch(error => {
				this.handleError(error);
			});
	}
	handlePhotoDelete = (id) => {
		this.props.deletePhoto(id)
			.then(response => {
				this.props.getPhotos(this.state.venue.id)
					.then(response => {
						let newState = {...this.state};
						newState.venue.photos = response.data;
						this.setState(newState);
						alert('Photo deleted');
					})
					.catch(error => {
						this.handleError(error);
					});
			})
			.catch(error => {
				this.handleError(error);
			});
	}
	handleMoodsChange = (moods) => {
		if(moods.length > 3) {
			alert('Maximum of 3 moods can be added');
			return;
		}

		let newState = {...this.state};
		newState.parameters.mood = moods;
		this.setState(newState);
	}
	handleOccasionsChange = (occasions) => {
		if(occasions.length > 4) {
			alert('Maximum of 4 occasions can be added');
			return;
		}

		let newState = {...this.state};
		newState.parameters.occasions = occasions;
		this.setState(newState);
	}
	handleCategoriesChange = (categories) => {
		let newState = {...this.state};
		newState.parameters.categories = categories;
		this.setState(newState);
	}
	handleProcessing = (event) => {

		const target = event.target;

		this.props.triggerProcessing(this.state.venue.id, target.name)
			.then(response => {
				console.log(response);
			})
			.catch(response => {
				console.log(response);
			});
	}
	render()
	{
		let title = (this.state.venue.name !== null) ? this.state.venue.name : "Venue Details";

		let types = this.state.tags.type.map(type => {
			return (
				<option key={type} value={type}>{_.startCase(type)}</option>
			);
		});

		let gallery = "";

		if (this.state.venue.id !== undefined)
		{
			gallery = (
				<div>
					<h2>Gallery</h2>
					<div className="image-upload">
						<h3>Upload new image</h3>
						<form onSubmit={this.submitUpload}>
							<input className="image-upload__file-input" type="file" ref={input => { this.fileInput = input; }} />
							<button className="image-upload__submit-btn btn" type="submit">Upload</button>
						</form>
					</div>
					<Gallery
						photos={this.state.venue.photos}
						updatePhoto={this.handlePhotoUpdate}
						deletePhoto={this.handlePhotoDelete}
					/>
				</div>
			);
		}

		let debug = (this.state.debug === true) ? (
			<pre id="debug">
				{JSON.stringify(this.state.venue, null, 4)}
			</pre>
		) : "";

		return (
			<div id="venue">
				<div id="info">{this.state.info}</div>
				<h1>{title}</h1>
				<form className="add-new-form" onSubmit={this.handleSubmit}>
					<div className="add-new-form__inner">
						<fieldset>
							<legend>Details</legend>
							<div className="form-input">
								<label>Name</label>
								<input type="text" name="name" value={this.state.parameters.name} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Description</label>
								<textarea name="description" value={this.state.parameters.description} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Expense</label>
								<select name="expense" value={this.state.parameters.expense} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised}>
									<option>Please Select...</option>
									<option value="1">£</option>
									<option value="2">££</option>
									<option value="3">£££</option>
									<option value="4">££££</option>
								</select>
							</div>
							<div className="form-input">
								<label>Special Offer</label>
								<input type="text" name="special" value={this.state.parameters.special} onChange={this.handleInputChange} disabled={!this.state.parameters.options.special} />
							</div>
						</fieldset>

						<fieldset>
							<legend>Tags</legend>
							<div className="form-input">
								<label>Type</label>
								<select name="type" value={this.state.parameters.type} onChange={this.handleInputChange}>
									<option>Please Select...</option>
									{types}
								</select>
							</div>
							<div className="form-input">
								<label>Mood</label>
								<Chips
									value={this.state.parameters.mood}
									onChange={this.handleMoodsChange}
									suggestions={this.state.tags.mood}
									fromSuggestionsOnly={true}
									uniqueChips={true}
									alwaysRenderSuggestions={true}
								/>
							</div>
							<div className="form-input">
								<label>Occasion</label>
								<Chips
									value={this.state.parameters.occasions}
									onChange={this.handleOccasionsChange}
									suggestions={this.state.tags.occasion}
									fromSuggestionsOnly={true}
									uniqueChips={true}
									alwaysRenderSuggestions={true}
								/>
							</div>
							<div className="form-input">
								<label>Categories <small>(after typing a new category press comma)</small></label>
								<div data-disabled={!this.state.parameters.options.customised}>
									<Chips
										value={this.state.parameters.categories}
										onChange={this.handleCategoriesChange}
									/>
								</div>
							</div>
						</fieldset>

						<fieldset>
							<legend>Options</legend>
							<div className="form-input">
								<label><input type="checkbox" name="options_blacklisted" checked={this.state.parameters.options.blacklisted} onChange={this.handleInputChange} /> Blacklisted</label>
							</div>
							<div className="form-input">
								<label><input type="checkbox" name="options_recommended" checked={this.state.parameters.options.recommended} onChange={this.handleInputChange} /> Recommended</label>
							</div>
							<div className="form-input">
								<label><input type="checkbox" name="options_rating" checked={this.state.parameters.options.rating} onChange={this.handleInputChange} /> Override Rating <input type="text" className="input-override-rating" name="override" value={this.state.parameters.override} onChange={this.handleInputChange} /></label>
							</div>
							<div className="form-input">
								<label><input type="checkbox" name="options_customised" checked={this.state.parameters.options.customised} onChange={this.handleInputChange} /> Customise Details</label>
							</div>
							<div className="form-input">
								<label><input type="checkbox" name="options_special" checked={this.state.parameters.options.special} onChange={this.handleInputChange} /> Special Offer</label>
							</div>
							<div className="form-input">
								<label><input type="checkbox" name="options_gallery" checked={this.state.parameters.options.gallery} onChange={this.handleInputChange} /> Hide Scraped Photos</label>
							</div>
							<input type="button" name="google" value="Google" onClick={this.handleProcessing} />
							<input type="button" name="foursquare" value="Foursquare" onClick={this.handleProcessing} />
						</fieldset>

						<fieldset>
							<legend>Address</legend>
							<div className="form-input">
								<label>Line 1</label>
								<input type="text" name="address_line1" value={this.state.parameters.address.line1} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Locality</label>
								<input type="text" name="address_locality" value={this.state.parameters.address.locality} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>City</label>
								<input type="text" name="address_city" value={this.state.parameters.address.city} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>County</label>
								<input type="text" name="address_state" value={this.state.parameters.address.state} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Postcode</label>
								<input type="text" name="address_postalCode" value={this.state.parameters.address.postalCode} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
						</fieldset>

						<fieldset>
							<legend>Contact</legend>
							<div className="form-input">
								<label>Phone</label>
								<input type="text" name="phone" value={this.state.parameters.phone} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Email</label>
								<input type="text" name="email" value={this.state.parameters.email} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Website</label>
								<input type="text" name="website" value={this.state.parameters.website} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
						</fieldset>

						<fieldset>
							<legend>Location</legend>
							<div className="form-input">
								<label>Latitude</label>
								<input type="text" name="location_latitude" value={this.state.parameters.location.coordinates[1]} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
							<div className="form-input">
								<label>Longitude</label>
								<input type="text" name="location_longitude" value={this.state.parameters.location.coordinates[0]} onChange={this.handleInputChange} disabled={!this.state.parameters.options.customised} />
							</div>
						</fieldset>
					</div>
					<div className="add-new-form__submit">
						<input type="submit" value="Save" className="btn" />
					</div>
				</form>

				<hr/>

				{gallery}

				<div>
					<input type="button" value="Toggle Debug" onClick={this.toggleDebug} />
					{debug}
				</div>
			</div>
		);
	}
}

class Gallery extends Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			data: {}
		};
	}
	render()
	{
		let trs = this.props.photos.map(photo => {
			return (
				<GalleryRow
					key={photo.id}
					photo={photo}
					updatePhoto={this.props.updatePhoto}
					deletePhoto={this.props.deletePhoto}
				/>
			);
		});

		return (
			<div className="gallery">
				<table className="gallery__table">
					<thead>
					<tr>
						<th>Thumbnail</th>
						<th>Source</th>
						<th>Attribution</th>
						<th>Hero?</th>
						<th>Actions</th>
					</tr>
					</thead>
					<tbody>
					{trs}
					</tbody>
				</table>
			</div>
		);
	}
}

class GalleryRow extends Component
{
	constructor(props)
	{
		super(props);

		this.state = {
			id: this.props.photo.id,
			attribution: this.props.photo.attribution || '',
			hero: this.props.photo.options.hero
		};
	}
	handleChange = (event) => {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		let state = {};
		state[name] = value;

		this.setState(state);
	}
	handleSubmit = () => {
		let parameters = {
			id: this.state.id,
			attribution: this.state.attribution || '',
			options: {
				hero: this.state.hero
			}
		};

		this.props.updatePhoto(parameters);
	}
	handleDeletePhoto = () => {
		this.props.deletePhoto(this.state.id);
	}
	render()
	{
		let url = (this.props.photo.source === "google") ? this.props.photo.url + "h200-w200" : this.props.photo.url.replace("100x100", "cap200");
		let largeUrl = (this.props.photo.source === "google") ? this.props.photo.url + "h1000-w1000" : this.props.photo.url.replace("100x100", "cap1000");

		// todo use label/link?
		let attribution = (this.props.photo.source === "custom") ? <input name="attribution" type="text" value={this.state.attribution} onChange={this.handleChange} /> : <span dangerouslySetInnerHTML={{ __html: this.state.attribution }}></span>;
		let deleteBtn = (this.props.photo.source === "custom") ? <button className="btn" onClick={this.handleDeletePhoto}>Delete</button> : null;

		return (
			<tr>
				<td>
					<a href={largeUrl} target="_blank">
						<img style={{maxHeight:200}} src={url} alt="" />
					</a>
				</td>
				<td>{_.startCase(this.props.photo.source)}</td>
				<td className="gallery__attribution">{attribution}</td>
				<td><input type="checkbox" name="hero" defaultChecked={this.state.hero} onChange={this.handleChange} /></td>
				<td className="gallery__btns">
					<button className="btn" onClick={this.handleSubmit}>Save</button>
					<br/>
					{deleteBtn}
				</td>
			</tr>
		);
	}
}

export default Venue;



// WEBPACK FOOTER //
// ./src/components/Venue.js